import { Card } from "@/components/ui/Card";
import type { EidSettings } from "@/data/types";
import { formatHHmmTo12h, formatIst } from "@/lib/time";

interface Props {
  settings: EidSettings;
}

function formatEidDate(iso: string | undefined): string {
  if (!iso) return "";
  const d = new Date(`${iso}T00:00:00.000Z`);
  if (Number.isNaN(d.getTime())) return "";
  return formatIst(d, "EEEE, d MMMM yyyy");
}

export function EidCard({ settings }: Props) {
  const time = formatHHmmTo12h(settings.time ?? "");
  const date = formatEidDate(settings.date);
  const announced = settings.isPublished && (time || date);

  return (
    <Card>
      <div className="label-eyebrow">Eid</div>
      <h3 className="mt-1 font-serif text-lg text-ink">Eid Salah</h3>

      {announced ? (
        <dl className="mt-4 space-y-2 text-sm">
          {settings.occasion ? (
            <div className="flex items-baseline justify-between">
              <dt className="text-muted">Occasion</dt>
              <dd className="text-ink">{settings.occasion}</dd>
            </div>
          ) : null}
          {date ? (
            <div className="flex items-baseline justify-between">
              <dt className="text-muted">Date</dt>
              <dd className="text-ink">{date}</dd>
            </div>
          ) : null}
          {time ? (
            <div className="flex items-baseline justify-between">
              <dt className="text-muted">Time</dt>
              <dd className="font-serif tabular-nums text-ink">{time}</dd>
            </div>
          ) : null}
          {settings.note ? (
            <p className="pt-2 text-sm leading-relaxed text-muted">{settings.note}</p>
          ) : null}
        </dl>
      ) : (
        <p className="mt-3 text-sm leading-relaxed text-muted">Time will be announced.</p>
      )}
    </Card>
  );
}
